import OnboardingWidget, { SetupStep } from './OnboardingWidget'

export default OnboardingWidget

export { SetupStep }
